import React, { useEffect, useRef, useState } from "react";
import { Markmap } from "markmap-view";
import Dialog from "@mui/material/Dialog";
import { AppBar } from "@mui/material";
import { PiTreeStructure } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";

import { getExecutionTree } from "../../store/actions";

const TreeView = ({ open, handleTreeViewClose }) => {
  const dispatch = useDispatch();
  const svgRef = useRef(null);
  const markmapRef = useRef(null);
  const [data, setData] = useState(null);

  const executionTree = useSelector(
      (state) => state.fetchGetExecutionTree
    );

  useEffect(() => {
    const bi_id = localStorage.getItem("bi_id");
    const product_id = localStorage.getItem("product_id");

    if (!bi_id || !product_id) return;

    dispatch(getExecutionTree(bi_id, product_id))


    // Cleanup (important when switching BI fast)
  }, []);

  useEffect(() => {
      if (executionTree) {
        setData(executionTree)
        console.log(executionTree)
      }
    }, [executionTree]);

  useEffect(() => {
    if (!svgRef.current || !data) return;

    if (!markmapRef.current) {
      markmapRef.current = Markmap.create(
        svgRef.current,
        {
          initialExpandLevel: 2,
          color: (node) => {
            if (node.state.depth === 1) return "#555"; // Product
            if (node.state.depth === 2) return "#1976d2"; // Department
            if (node.state.depth === 3) return "#2e7d32"; // Functional Goal
            if (node.state.depth === 4) return "#ed6c02"; // Milestone
            return "#555";
          },
          spacingVertical: 10,
        },
        data,
      );
      window._mm = markmapRef.current; // ADD THIS LINE
    } else {
      markmapRef.current.setData(data);
      markmapRef.current.fit();
    }
  }, [data]);

  const handleExpandAll = async () => {
  if (!markmapRef.current) return;

  const internalData = markmapRef.current.state.data;

  const expandAllNodes = (node) => {
    if (!node) return;
    if (node.payload) node.payload.fold = 0;
    if (node.children?.length) node.children.forEach(expandAllNodes);
  };

  expandAllNodes(internalData);
  await markmapRef.current.renderData();
  markmapRef.current.fit();
};

  return (
    // <div style={{ width: "800px", height: "600px" }}>
    <Dialog
      fullScreen
      open={open}
      PaperProps={{
        sx: {
          opacity: open ? 1 : 0,
          // transform: open ? "scale(1)" : "scale(0.98)",
          transition: "all 350ms ease",
        },
      }}
      // onClose={handleClose}
    >
      <AppBar
        sx={{
          position: "relative",
          backgroundColor: "#0a5f59",
          boxShadow: "none",
          color: "white",
          borderBottom: "1px solid #c5c5c5",
        }}
      >
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', height:'40', padding:'10px 20px'}} >

          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}} >
          <PiTreeStructure fontSize={24} />
          <div
            style={{
              fontSize: "var(--main-heading)",
              // fontWeight: "var(--heading-font-weight)",
              marginLeft: "10px"
            }}
          > 
            Execution Plan Tree View
          </div>
          </div>
          
          <div>
            <button
            style={{
              color: "black",
              border: "1px solid white",
              background: "white",
              padding: "5px 15px",
              borderRadius: "5px",
            }}
            onClick={handleExpandAll}
          >
            Expand All
          </button>
          <button
            style={{
              color: "white",
              border: "1px solid white",
              background: "none",
              padding: "5px 15px",
              borderRadius: "5px",
              marginLeft:'10px'
            }}
            onClick={handleTreeViewClose}
          >
            Close
          </button>
          </div>
          
        </div>
      </AppBar>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        {/* 🔹 Instruction Box */}
        <div
          style={{
            position: "absolute",
            left: 20,
            top: 20,
            zIndex: 10,
            background: "rgba(179, 236, 213, 0.3)",
            backdropFilter: "blur(6px)",
            color: "#505050",
            border: "1px solid rgb(172, 201, 189)",
            padding: "12px 16px",
            borderRadius: "8px",
            fontSize: "13px",
            maxWidth: "260px",
            lineHeight: 1.5,
          }}
        >
          {/* <strong>Instructions</strong> */}
          <ul style={{ margin: "0 0 0 16px", padding: 0 }}>
            <li>Scroll to zoom</li>
            <li>Drag to move</li>
            <li>Click node to expand/collapse</li>
            <li>Ctrl + Click node to toggle recursively</li>
          </ul>
        </div>

        {/*  Mindmap */}
        <svg ref={svgRef} style={{ width: "100%", height: "100%" }} />
      </div>
    </Dialog>

    // </div>
  );
};

export default TreeView;
